/* eslint-disable no-underscore-dangle,react/prop-types */
import { BrowserProtocol, queryMiddleware } from 'farce';
import {
  createBrowserRouter,
  // createFarceRouter,
  createRender,
} from 'found';
import { createNamedRoutesMiddleware } from 'found-named-routes';
// import { Resolver } from 'found-relay/lib/classic';
import React from 'react';
// import fromGraphQL from 'react-relay/lib/fromGraphQL';

import Loading from 'components/Loading';
// import { getEnvironment } from 'lib/relayUtils';
import routeConfig from 'lib/routeConfig';
import ErrorPage from 'pages/Error';
import NotAuthorizedPage from 'pages/NotAuthorized';
import NotFoundPage from 'pages/NotFound';

const namedRoutesMiddleware = createNamedRoutesMiddleware(routeConfig);

export const historyMiddlewares = [namedRoutesMiddleware, queryMiddleware];

export const historyProtocol = new BrowserProtocol();

export const renderError = ({ error }) => {
  switch (error.status) {
    case 401:
      return <NotAuthorizedPage />;
    case 404:
      return <NotFoundPage />;
    default:
      return <ErrorPage />;
  }
};
export const renderPending = () => <Loading />;

export const render = createRender({
  renderError,
  renderPending,
});

export const createDevelopmentBrowserRouter = () => createBrowserRouter({
    historyMiddlewares: [namedRoutesMiddleware, queryMiddleware],
    render,
    routeConfig,
  });

export const createProductionBrowserRouter = async () => {
  // const environment = getEnvironment();
  // const preparedData = window.__INITIALDATA__ || [];
  // if (preparedData.length > 0) {
  //   const storeData = environment.getStoreData();
  //   preparedData.forEach(({ query: concreteQuery, response }) => {
  //     const query = fromGraphQL.Query(concreteQuery);
  //     storeData.handleQueryPayload(query, response);
  //   });
  // }
  return createBrowserRouter({
    historyProtocol,
    historyMiddlewares: [namedRoutesMiddleware, queryMiddleware],
    render,
    // resolver: new Resolver(environment),
    routeConfig,
  });
};
